import { END_SESSION } from '../actions/authActions';
import { SET_BANK_ACCOUNTS } from '../actions/bankAccountActions';
import { UNSUBSCRIBE_CURRENT_ACCOUNT } from '../actions/currentAccountActions';

const DEFAULT_STATE = [];

export default function bankAccountsReducer(state = DEFAULT_STATE, { type, payload = [] }) {
  switch (type) {
    case END_SESSION:
    case UNSUBSCRIBE_CURRENT_ACCOUNT:
      return DEFAULT_STATE;
    case SET_BANK_ACCOUNTS:
      return payload;
    default:
      return state;
  }
}
